import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crazy-radio',
  template: `
<mat-radio-group>
    <mat-radio-button value="1">Option 1</mat-radio-button>
    <mat-radio-button value="2">Option 2</mat-radio-button>
</mat-radio-group>
<button mat-button>Material button</button>
`,
  styles: []
})
export class CrazyRadioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
